import React from 'react';
/* import { ColorModeProvider, Preflight } from '@xstyled/styled-components'; */
import { Preflight } from '@xstyled/styled-components';
import { MDXProvider } from 'smooth-doc/src/components/MDX';
/* import { GlobalStyle, ThemeProvider } from './Theme'; */

import {
  createGlobalStyle,
  ThemeProvider as SCThemeProvider,
  th
} from '@xstyled/styled-components';
import { theme } from '../theme';

export const GlobalStyle = createGlobalStyle`
  ${th('global')}
`;

export function ThemeProvider({ children }) {
  return <SCThemeProvider theme={theme}>{children}</SCThemeProvider>;
}

export function RootWrapper({ children }) {
  return (
    <ThemeProvider>
      {/* <ColorModeProvider> */}
      <Preflight />
      <GlobalStyle />
      <MDXProvider>{children}</MDXProvider>
      {/* </ColorModeProvider> */}
    </ThemeProvider>
  );
}
